var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"el-upload-dragger",class:{
    'is-dragover': _vm.dragover
  },on:{"dragleave":function($event){$event.preventDefault();_vm.dragover = false},"dragover":function($event){$event.preventDefault();return _vm.onDragover($event)},"drop":function($event){$event.preventDefault();return _vm.onDrop($event)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }